<div class="order-counter">
    <ion-icon name="remove-outline" (click)="removeClicked($event)"></ion-icon>
    <div class="count-display count-details-active">
        <span>{{value}}</span>
    </div>
    <ion-icon name="add-outline" (click)="addClicked($event)"></ion-icon>
</div>
